import { Container, Text } from 'pixi.js';

/**
 * Floating damage numbers that rise and fade out.
 */
export class DamageNumbers {
  constructor(worldContainer) {
    this.worldContainer = worldContainer;
    this.numbers = []; // { text, x, y, age, maxAge }
  }

  /**
   * Spawn a floating damage number at the given world position.
   * @param {number} x - World X position
   * @param {number} y - World Y position
   * @param {number|string} amount - Damage amount or text to display
   * @param {number} color - Color of the text (default white)
   */
  spawn(x, y, amount, color = 0xffffff) {
    const colorStr = '#' + color.toString(16).padStart(6, '0');
    const text = new Text({
      text: String(amount),
      style: {
        fontFamily: 'monospace',
        fontSize: 10,
        fill: colorStr,
        fontWeight: 'bold',
        stroke: { color: '#000000', width: 2 },
      },
    });
    text.anchor = { x: 0.5, y: 0.5 };
    text.x = x;
    text.y = y;

    this.worldContainer.addChild(text);

    this.numbers.push({
      text,
      x,
      y,
      age: 0,
      maxAge: 0.5,
    });
  }

  /**
   * Update all active damage numbers: float up and fade out.
   * @param {number} dt - Delta time in seconds
   */
  update(dt) {
    for (let i = this.numbers.length - 1; i >= 0; i--) {
      const num = this.numbers[i];
      num.age += dt;
      num.y -= 30 * dt; // float upward at 30px/sec
      num.text.x = num.x;
      num.text.y = num.y;

      // Fade out
      const progress = num.age / num.maxAge;
      num.text.alpha = Math.max(0, 1 - progress);

      if (num.age >= num.maxAge) {
        this.worldContainer.removeChild(num.text);
        num.text.destroy();
        this.numbers.splice(i, 1);
      }
    }
  }

  /**
   * Clean up all active damage numbers.
   */
  destroy() {
    for (const num of this.numbers) {
      this.worldContainer.removeChild(num.text);
      num.text.destroy();
    }
    this.numbers.length = 0;
  }
}
